import axios from 'axios';

interface ProblemDetail {
  status?: number;
  title?: string;
  detail?: string;
  code?: string;
}

export interface ParsedProblemDetail {
  status: number | undefined;
  detail: string;
  /**
   * The server's stable, snake_case identifier for the failure, when it sent
   * one. A status alone cannot tell two 409s apart, and `detail` is an English
   * sentence written for a human - keying behaviour or a translated message on
   * this is the only option that survives both a reworded sentence and a second
   * conflict on the same route.
   */
  code: string | undefined;
}

/**
 * Pulls the RFC 7807 detail message and stable `code` off an axios error so
 * callers can render it inline, or pick their own translated message, instead of
 * relying on the global toast interceptor. Falls back to `fallback` when the
 * response did not carry a Problem Detail body.
 */
export function parseProblemDetail(error: unknown, fallback: string): ParsedProblemDetail {
  if (axios.isAxiosError(error) && error.response) {
    const data = error.response.data as ProblemDetail | undefined;
    return {
      status: data?.status ?? error.response.status,
      detail: data?.detail ?? data?.title ?? fallback,
      code: data?.code,
    };
  }
  return { status: undefined, detail: fallback, code: undefined };
}
